module.exports = __webpack_public_path__ + "static/nick-e576ce4ef608b76ba11e40c0bec2c5c7.jpg";